import { TrackedEvent } from "@/domains/metrics";
import { trackEvent } from "@/domains/metrics";
import { FileDropItemWithPath } from "@/modules/file/dropItems";
import { pluralize } from "@/modules/pluralize";
import { AppStore } from "@/store";

export const importFilesAsSession = async (files: FileDropItemWithPath[], store: AppStore) => {
  const start = performance.now();
  const droppedFilesCount = files.length;

  // Create a session for this import
  const sessionId = await store.sessions.createSession({
    title: `Bring in ${droppedFilesCount} ${pluralize(droppedFilesCount, "file", "files")}`,
    status: "PROCESSING",
    kind: "IMPORT",
  });

  // Create a file batch for these files
  const batchId = await store.uploadedFileBatches.createUploadedFileBatch({
    sessionId,
    //config: { create_collections_from_tags: true }, // TODO: remove once we're including this as an Input Request event
  });

  // Upload files
  store.sessionEvents.createMessageSentSessionEvent({
    session_id: sessionId,
    message_value: {
      kind: "REASONING",
      content: `Uploading ${droppedFilesCount} ${pluralize(droppedFilesCount, "file", "files")}`,
    },
  });

  const uploadedFileIds = await store.uploadProgress.uploadFileItems(files);

  // Create File Upload models using accumulated results
  const uploadedFileResults = store.uploadProgress.getFileResults(uploadedFileIds);
  await store.uploadedFiles.createUploadedFiles({ batchId, uploadedFileResults });

  // Add all uploads to the batch
  await store.uploadedFileBatches.addUploadsToBatch(batchId, uploadedFileIds);

  // Start processing the batch
  await store.uploadedFileBatches.startProcessingBatch(batchId, sessionId);

  // Track event
  trackEvent(TrackedEvent.ImportFilesBatchStarted, {
    num_files: uploadedFileResults.length,
    batch_id: batchId,
    session_id: sessionId,
    upload_duration_s: (performance.now() - start) / 1000,
  });
};
